import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { SMLUpgradeFeature } from '../../../config/music24PlanCapabilities';
import { planNameMessages } from '../../../config/music24PlanNames';
import { useNextPlanForFeature } from '../../../hooks/useNextPlanForFeature';
import { FanReleaseCard } from './FanReleaseCard';
import { fanReleaseMessages as messages } from './overviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole card; each part uses its own slice of it */
import styles from './FanReleasePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface FanReleasePlanStateProps {
  title: string;
  count: number;
  /** "On Artist, $19 a month", or null when no plan is named. */
  lockLabel: string | null;
  onSeePlans: () => void;
}

/** "Send to your subscribers" on a plan with no pre-saves (design presave-subscriptions d2, state 6). */
const FanReleasePlanStateComponent: React.FC<FanReleasePlanStateProps> = ({ title, count, lockLabel, onSeePlans }) => {
  const intl = useIntl();
  const { nextPlan } = useNextPlanForFeature(SMLUpgradeFeature.presave);
  const plan = intl.formatMessage(planNameMessages[nextPlan?.tier ?? 'artist']);

  return (
    <FanReleaseCard
      badge={lockLabel === null ? undefined : <span className={styles.lockChip}>{lockLabel}</span>}
      title={intl.formatMessage(messages.planTitle, { title, count })}
      body={intl.formatMessage(messages.planBody, { title, plan })}
    >
      <div className={styles.actions}>
        <SMLButton variant="primary" onClick={onSeePlans}>
          {intl.formatMessage(messages.seePlans)}
        </SMLButton>
      </div>
    </FanReleaseCard>
  );
};

export const FanReleasePlanState = TypedMemo(FanReleasePlanStateComponent);
